<template>
  <vx-card title="商品信息" class="mb-10" v-if="p && p.id">
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-sm="12" vs-w="6" class="mb-2">
        <b>商品名称：</b>
        <router-link :to="'/product/edit/' + p.id" target="_blank">{{p.name}}</router-link>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-sm="12" vs-w="6" class="mb-2" v-if="p.spec">
        <b>商品型号/规格：</b>{{p.spec}}
      </vs-col>
      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-sm="12" vs-w="6" class="mb-2" v-if="p.saleSite">
        <b>网店销售地址：</b> <a :href="p.saleSite" target="_blank">点击跳转</a>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-sm="12" vs-w="6" class="mb-2" v-if="p.saleAddr">
        <b>商品介绍地址：</b> <a :href="p.saleAddr" target="_blank">点击跳转</a>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-sm="12" vs-w="6" class="mb-2" v-if="p.promise">
        <b>服务承诺：</b>{{p.promise}}
      </vs-col>
      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-sm="12" vs-w="6" class="mb-2" v-if="p.desc">
        <b>商品简介：</b>{{p.desc}}
      </vs-col>
      <vs-col vs-sm="12" vs-w="6" class="mb-2" v-if="p.content">
        <b>商品详情：</b>
        <span @click="showDetail=true" class="cursor-pointer text-primary">查看</span>
        <vs-popup class="holamundo"  title="商品详情" :active.sync="showDetail">
          <div v-html="p.content"></div>
        </vs-popup>
      </vs-col>
    </vs-row>
  </vx-card>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showDetail: false,
    }
  },
  computed: {
    p() {
      return this.product || this.data
    }
  },
  mounted() {
    if (this.$route.params.batchID) {
      this.$s.product.batchNoDetail(this.$route.params.batchID)
    }
  },
  $computed: ['product.batchno.product']
}
</script>